import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/** Capture a DOM node (charts + KPI cards) into a clean A4 PDF with a branded header. */
export async function exportNodeToPdf(node, { title, subtitle, filename }) {
  const canvas = await html2canvas(node, { backgroundColor: '#0f172a', scale: 2, useCORS: true });
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
  const W = pdf.internal.pageSize.getWidth();
  const H = pdf.internal.pageSize.getHeight();

  pdf.setFillColor(15, 23, 42);
  pdf.rect(0, 0, W, 64, 'F');
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(16);
  pdf.text(title, 28, 30);
  pdf.setFontSize(10);
  pdf.setTextColor(148, 163, 184);
  pdf.text(subtitle || '', 28, 48);

  const imgW = W - 56;
  const imgH = (canvas.height * imgW) / canvas.width;
  const firstH = H - 84;
  const img = canvas.toDataURL('image/png');
  if (imgH <= firstH) {
    pdf.addImage(img, 'PNG', 28, 74, imgW, imgH);
  } else {
    // Slice tall captures across pages
    const pxPerPt = canvas.width / imgW;
    let offset = 0, first = true;
    while (offset < canvas.height) {
      const slicePt = first ? firstH : H - 40;
      const slicePx = Math.min(slicePt * pxPerPt, canvas.height - offset);
      const part = document.createElement('canvas');
      part.width = canvas.width; part.height = slicePx;
      part.getContext('2d').drawImage(canvas, 0, offset, canvas.width, slicePx, 0, 0, canvas.width, slicePx);
      if (!first) pdf.addPage();
      pdf.addImage(part.toDataURL('image/png'), 'PNG', 28, first ? 74 : 20, imgW, slicePx / pxPerPt);
      offset += slicePx; first = false;
    }
  }
  pdf.save(filename);
}
